var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "call_end"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_354_494",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_354_494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "call_end_2",
    d: "M2.26654 10.9333L0.733203 9.43331C0.59987 9.29998 0.533203 9.14442 0.533203 8.96665C0.533203 8.78887 0.59987 8.63331 0.733203 8.49998C1.71098 7.44442 2.83876 6.65276 4.11654 6.12498C5.39431 5.5972 6.68876 5.33331 7.99987 5.33331C9.31098 5.33331 10.6026 5.5972 11.8749 6.12498C13.1471 6.65276 14.2776 7.44442 15.2665 8.49998C15.3999 8.63331 15.4665 8.78887 15.4665 8.96665C15.4665 9.14442 15.3999 9.29998 15.2665 9.43331L13.7332 10.9333C13.611 11.0555 13.4693 11.1222 13.3082 11.1333C13.1471 11.1444 12.9999 11.1 12.8665 11L10.9332 9.53331C10.8443 9.46665 10.7776 9.38887 10.7332 9.29998C10.6888 9.21109 10.6665 9.11109 10.6665 8.99998V7.09998C10.2443 6.96665 9.81098 6.86109 9.36654 6.78331C8.92209 6.70554 8.46654 6.66665 7.99987 6.66665C7.5332 6.66665 7.07765 6.70554 6.6332 6.78331C6.18876 6.86109 5.75543 6.96665 5.3332 7.09998V8.99998C5.3332 9.11109 5.31098 9.21109 5.26654 9.29998C5.22209 9.38887 5.15543 9.46665 5.06654 9.53331L3.1332 11C2.99987 11.1 2.85265 11.1444 2.69154 11.1333C2.53043 11.1222 2.38876 11.0555 2.26654 10.9333ZM3.99987 7.63331C3.67765 7.79998 3.36654 7.99165 3.06654 8.20831C2.76654 8.42498 2.45543 8.66665 2.1332 8.93331L2.79987 9.59998L3.99987 8.66665V7.63331ZM11.9999 7.66665V8.66665L13.1999 9.59998L13.8665 8.96665C13.5443 8.67776 13.2332 8.42776 12.9332 8.21665C12.6332 8.00554 12.3221 7.8222 11.9999 7.66665Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallEnd);
export default __webpack_public_path__ + "static/media/call_end.0ef86610a1e6890785e7041041f57ea4.svg";
export { ForwardRef as ReactComponent };